import React, { useEffect } from "react";
import PageHeader from "~/common/components/PageHeader";

import "~/assets/sass/pages/vcInfo/detail.scss";
import DarkRecInitialImg from "~/assets/img/defaultImg/dark-logo-rec.png";
import LightRecInitialImg from "~/assets/img/defaultImg/light-logo-rec.png";
import { useGlobalStore } from "~/store";
import useRepository from "~/common/hooks/useRepository";
import { COMPANY_INFO } from "~/store/company/repository";
import { dateToString, faxNumberFormatter, phoneNumberFormatter } from "~/utils/formatter";
import "./strong.css";

import { useTranslation } from "react-i18next";
import useAlert from "~/common/hooks/useAlert";
import BusinessAuth from "../BusinessAuth";

const Detail = ({ setPage, menu, type }) => {
	const { t } = useTranslation();
	const [
		{
			company: { info },
			sidebar: { currentPath },
			theme: { theme },
		},
	] = useGlobalStore();

	const [showAuthAlert, AuthAlert] = useAlert();

	const buttonList = [
		<button
			type="button"
			className="btn__solid"
			color="primary"
			onClick={() => {
				if (currentPath.auth !== "edit") {
					showAuthAlert();
					return;
				}
				setPage("edit");
			}}
		>
			{t("common.commonWord.button.Edit")}
		</button>,
	];

	const [getCompanyInfo] = useRepository(COMPANY_INFO);

	useEffect(() => {
		getCompanyInfo();
		console.log(info)
	}, []);

	return (
		<>
			<PageHeader {...{ menu, type, buttonList }} />
			<div className="c__card vc-info-detail">
				<div className="data-form top">
					<section className="vc-logo">
						<div className="logo-wrap after">
							<img
								src={
									info.company?.logoRec ||
									(theme === "dark" ? DarkRecInitialImg : LightRecInitialImg)
								}
								alt={t("pages.vcInfo.VcInformation.Detail.logo")}
								onError={(e) => {
									e.target.src =
										theme === "dark" ? DarkRecInitialImg : LightRecInitialImg;
								}}
							/>
						</div>
					</section>
					<section className="vc-desc">
						<div className="vc-title">{info.company?.introTitle}</div>
						<div className="vc-text">
							<div dangerouslySetInnerHTML={{ __html: info.company?.introContent || "" }} />
							{/* {info.company?.introContent && info.company?.introContent.split("\n").map((text) => {
                                return (
                                    <span>
                                        {text}
                                        <br />
                                    </span>
                                )
                            })
                            } */}
						</div>
					</section>

				</div>
				<div className="data-form bottom">
					<div className="vc-card">
						<div className="vc-title">
							<p className="vc-name">{info.company?.name}</p>
							<span className="vc-setup">
								since {dateToString(info.company?.estDate, "yyyy")}
							</span>
						</div>
						<ul className="vc-info">
							<li>Phone : +82 {phoneNumberFormatter(info.company?.ceoContact)}</li>
							{info.company?.fax && <li>Fax : +82 {faxNumberFormatter(info.company?.fax)}</li>}
							<li>
								{t("pages.vcInfo.VcInformation.Detail.employeeNum")} :{" "}
								{info.company?.employeeNum}
							</li>
							<li>{info.company?.homepage}</li>
							<li>{info.company?.ceoEmail}</li>
							<li>
								{info.company?.address} {info.company?.addressDetail} {info.company?.zipCode}
							</li>
						</ul>
					</div>

					{info.company?.CompanyKeyword && info.company?.CompanyKeyword.length > 0 && (
						<div className="vc-interest">
							<div className="f__label">
								{t("pages.vcInfo.VcInformation.Detail.interests")}
							</div>
							<ul className="vc-interest-tag">
								{info.company?.CompanyKeyword?.map((d) => (
									<li key={d.idx} className="c__tag-view">
										{d.content}
									</li>
								))}
							</ul>
						</div>
					)}

				</div>
				<section className="footer-wrapper">
					<BusinessAuth info={info} />
					<section>
						{info.signature?.img && (
							<div className="seal-area">
								<div className="selected-signature">
									<img
										src={info.signature?.img}
										alt={t("pages.vcInfo.VcInformation.Detail.stamp")}
									/>
								</div>
							</div>
						)}
					</section>
				</section>
			</div>
			<AuthAlert
				message={
					<>
						권한이 없습니다. <br />
						관리자에게 문의하세요.
					</>
				}
				type="warning"
				confirm="확인"
			/>
		</>
	);
};

export default Detail;
